import { BydCleanInstance } from '@sixense/byd-clean-instance';
import { DsFormTypeEnum } from '../enums/ds-forms.enum';
import { DsFormInstanceSchemaFieldInterface } from '../interfaces/form-instance/ds-form-instance-schema-field.interface';
import { DsFormInstanceTableValueInterface } from '../interfaces/form-instance/ds-form-instance-table-value.interface';
import { DsFormInstanceFieldValueType } from '../types/ds-form-instance-field-value.type';
import { DsFormInstanceTableValueFront } from './ds-form-instance-table-value-front';

@BydCleanInstance
export class DsFormInstanceSchemaFieldFront {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public value: DsFormInstanceFieldValueType;

  /**
   *
   */
  public option?: string[] | string[][];

  /**
   *
   */
  public comment?: string;

  /**
   *
   */
  public photos?: string[] | string[][];

  /**
   * Documents.
   */
  public documents?: string[] | string[][];

  /**
   *
   */
  public isFixed?: boolean;

  /**
   *
   */
  public isLocked?: boolean;

  /**
   *
   */
  public isSigned?: boolean;

  /**
   *
   */
  public rowCount?: number;

  /**
   *
   */
  public cellPhotos?: string[] | string[][];

  /**
   *
   */
  public cellDocuments?: string[] | string[][];

  /**
   * Creates an instance of DsFormInstanceSchemafieldFront.
   *
   * @param json the json data
   * @param template instance template
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: DsFormInstanceSchemaFieldInterface = null, template?: any) {
    this.id = json?.id || template?.id;

    this.isFixed = json?.isFixed || false;
    this.isLocked = json?.isLocked || false;
    this.isSigned = json?.isSigned || false;
    this.comment = json?.comment || null;
    if (
      template?.isPhotoEnabled ||
      template?.type === DsFormTypeEnum.SIGNATURE ||
      template?.type === DsFormTypeEnum.PHOTO
    ) {
      this.photos = json?.photos ? [json.photos] : [[]];
    }

    if (template?.type === DsFormTypeEnum.DOCUMENT) this.documents = json?.documents ? [json.documents] : [[]];

    switch (template?.type) {
      case DsFormTypeEnum.DATE:
      case DsFormTypeEnum.DATETIME:
        this.value = json?.value ?? null;
        break;
      case DsFormTypeEnum.PHOTO:
      case DsFormTypeEnum.DOCUMENT:
        this.value = json?.value ? ([json.value] as string[][]) : [[]];
        break;
      case DsFormTypeEnum.LISTBOX:
        if (template?.multichoice) this.value = json?.value ? ([json.value] as number[][]) : [[]];
        else this.value = json?.value !== undefined ? json?.value : null;
        break;
      case DsFormTypeEnum.STATIC_TABLE:
      case DsFormTypeEnum.DYNAMIC_TABLE:
        this.cellPhotos = json?.cellPhotos !== undefined ? [json.cellPhotos] : [[]];
        this.cellDocuments = json?.cellDocuments !== undefined ? [json.cellDocuments] : [[]];
        if (template?.type === DsFormTypeEnum.STATIC_TABLE) this.rowCount = template.rows?.length ?? 0;
        else this.rowCount = json?.rowCount !== undefined ? json?.rowCount : 0;
        this.value = new DsFormInstanceTableValueFront(<DsFormInstanceTableValueInterface[]>json?.value, this.rowCount);
        break;

      default:
        this.value = json?.value !== undefined ? json?.value : null;
    }
  }
}
